import { FC, PropsWithChildren, SVGProps } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';

export type SvgProps = SVGProps<SVGSVGElement>;

const Svg: FC<PropsWithChildren<PropsWithClassName<SvgProps>>> = ({ className, children, ...props }) => {
  return (
    <svg className={cn(className)} {...props}>
      {children}
    </svg>
  );
};

export default Svg;
